import { render, staticRenderFns } from "./PaymentLimitModel.vue?vue&type=template&id=2921d0d5&"
import script from "./PaymentLimitModel.vue?vue&type=script&lang=js&"
export * from "./PaymentLimitModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports